export enum FleetColumns {
  FRIENDLY_NAME,
  DEVICE_TWIN_COUNT,
  CREATED_AT,
  MODIFIED_AT,
  INCOMPATIBLE_DEVICE_TWIN_COUNT,
  ACTION,
  TOOLTIP,
}
